// Mock data for Maine Airbnb Website

export const propertyData = {
  title: "Acadia Schoodic Oceanfront Luxury",
  subtitle: "5BR | Oceanfront • Jacuzzi • Firepit",
  tagline: "Wake up to panoramic lighthouse and harbor views on Acadia's peaceful Schoodic Peninsula",
  description: "Welcome to your coastal Maine retreat. Soak in the 7-seater Jacuzzi, gather at the 10-seater Solo Stove fire pit, and wake up to stunning lighthouse and harbor views. This oceanfront retreat with private beach access on Acadia's peaceful Schoodic Peninsula sleeps 12 across 5 bedrooms with panoramic water views from all rooms. Enjoy swings, outdoor dining, and nautical elegance throughout. Perfect for families and groups seeking a one-of-a-kind Maine getaway.",
  
  airbnbUrl: "https://www.airbnb.com/rooms/1411071628689314814",
  
  highlights: [
    {
      icon: "Home",
      title: "Oceanfront Paradise",
      description: "Newly remodeled nautical-themed home with panoramic Atlantic Ocean views from every bedroom"
    },
    {
      icon: "MapPin",
      title: "10-min to Acadia",
      description: "On the peaceful Schoodic Peninsula side of Acadia National Park with private beach access"
    },
    {
      icon: "Waves",
      title: "Lighthouse & Harbor Views",
      description: "Watch lobster boats drift across the harbor with a working lighthouse as your backdrop"
    },
    {
      icon: "Trees",
      title: "7-Person Hot Tub",
      description: "Soak under the stars with ocean views, plus Solo Stove fire pit seating for 10"
    }
  ],

  amenities: [
    { icon: "Waves", name: "Beach Access", category: "outdoor" },
    { icon: "Coffee", name: "Full Kitchen", category: "kitchen" },
    { icon: "Wifi", name: "High-Speed WiFi", category: "essentials" },
    { icon: "Bed", name: "Dedicated Workspace", category: "essentials" },
    { icon: "ParkingCircle", name: "Free Parking", category: "essentials" },
    { icon: "Bath", name: "Hot Tub (7-person)", category: "luxury" },
    { icon: "Footprints", name: "Pets Allowed", category: "policies" },
    { icon: "Tv", name: "Smart TV", category: "entertainment" },
    { icon: "ParkingCircle", name: "EV Charger - Level 2", category: "essentials" },
    { icon: "Flame", name: "Solo Stove Fire Pit", category: "outdoor" },
    { icon: "TreePine", name: "Outdoor Swings", category: "outdoor" },
    { icon: "Utensils", name: "Outdoor Dining", category: "outdoor" },
    { icon: "Home", name: "Self Check-in", category: "essentials" },
    { icon: "Coffee", name: "Coffee Maker", category: "kitchen" },
    { icon: "Shirt", name: "Washer & Dryer", category: "essentials" }
  ],

  reviews: [
    {
      id: 1,
      guest: "Amy",
      location: "Severn, Maryland",
      rating: 5,
      date: "August 2025",
      text: "We had an absolutely lovely stay! The house was even better than the photos! Very quiet and private with a beautiful view. The hosts were super responsive and accommodating. We highly recommend this beautiful home and look forward to staying here again!!",
      highlight: "Even better than photos!"
    },
    {
      id: 2,
      guest: "Petro",
      location: "Guest",
      rating: 5,
      date: "July 2025",
      text: "Thank you for hosting us at this amazing property. The house was newly remodeled so everything was in great shape. Everyone enjoyed the house and its design, especially the cool little surprises we found throughout the premises: stairs lighting up and the popcorn machine. The property offered amazing views of the harbor and a nice, peaceful space outside to unwind.",
      highlight: "Amazing views & peaceful space"
    },
    {
      id: 3,
      guest: "Megan",
      location: "Bluff City, Tennessee",
      rating: 5,
      date: "June 2025",
      text: "This house is perfect. I would highly recommend staying here for a relaxing time. Very clean! We loved our stay!",
      highlight: "Perfect & very clean"
    },
    {
      id: 4,
      guest: "Amy",
      location: "Guest",
      rating: 5,
      date: "August 2025",
      text: "The place was great for two families of five. The hot tub was a nice amenity and the view/area was very beautiful. Would definitely stay again!",
      highlight: "Great for families"
    },
    {
      id: 5,
      guest: "Ellen",
      location: "Guest",
      rating: 4,
      date: "September 2025",
      text: "Our group of 9 women really enjoyed the house. The backyard with the fire pit, Adirondack chairs, and the hot tub, along with the amazing water view were spectacular!",
      highlight: "Spectacular backyard & water views"
    },
    {
      id: 6,
      guest: "Rosalenda",
      location: "Guest",
      rating: 4,
      date: "October 2025",
      text: "The house was beautiful. Setting gorgeous. Well appointed. The backyard with stunning ocean views made for an unforgettable stay.",
      highlight: "Beautiful & gorgeous setting"
    }
  ],

  propertyDetails: {
    guests: 12,
    bedrooms: 5,
    beds: 7,
    bathrooms: 3,
    checkIn: "4:00 PM",
    checkOut: "11:00 AM",
    propertyType: "Entire home",
    rating: 4.78,
    reviewCount: 9
  },

  houseRules: [
    "Check-in after 4:00 PM",
    "Check-out before 11:00 AM",
    "12 guests maximum",
    "Self check-in with smartlock",
    "Pets allowed",
    "No smoking inside",
    "Exterior security cameras on property"
  ],

  photos: [
    {
      id: 1,
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/ee0846e1-39f7-4bb5-b1ef-4b33462b7fd1.jpeg?im_w=1200",
      alt: "Oceanfront view with lighthouse",
      category: "exterior"
    },
    {
      id: 2,
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/db26ca03-ba17-4a05-9acd-65d135bf525c.jpeg?im_w=1200",
      alt: "Outdoor seating with ocean views",
      category: "outdoor"
    },
    {
      id: 3,
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/e0d95acf-ce42-433e-aec1-0243fb05bebf.jpeg?im_w=1200",
      alt: "Living area with ocean views",
      category: "interior"
    },
    {
      id: 4,
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/260921f9-6c55-4b23-96ad-35bc6c4d2903.jpeg?im_w=1200",
      alt: "Modern kitchen with dining area",
      category: "kitchen"
    },
    {
      id: 5,
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/04a35278-8ba2-42ca-9ccc-cd726f5bf521.jpeg?im_w=1200",
      alt: "Bedroom with ocean views",
      category: "bedroom"
    },
    {
      id: 6,
      url: "https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/15f9fb0d-d272-4212-bd87-dbe42705c9aa.jpeg?im_w=1200",
      alt: "Master bedroom",
      category: "bedroom"
    }
  ],

  heroImages: [
    {
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/ee0846e1-39f7-4bb5-b1ef-4b33462b7fd1.jpeg?im_w=1920",
      alt: "Oceanfront property with lighthouse view"
    },
    {
      url: "https://images.pexels.com/photos/35046715/pexels-photo-35046715.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
      alt: "Bass Harbor Lighthouse at sunset"
    },
    {
      url: "https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/db26ca03-ba17-4a05-9acd-65d135bf525c.jpeg?im_w=1920",
      alt: "Outdoor living space with harbor views"
    },
    {
      url: "https://images.pexels.com/photos/29360923/pexels-photo-29360923.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
      alt: "Schoodic Point coastline"
    },
    {
      url: "https://images.pexels.com/photos/15964419/pexels-photo-15964419.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920",
      alt: "Fishing boats and lobster traps in Prospect Harbor"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_78f06497-a3e7-4eb9-83ca-6637a8976a72/artifacts/13088swm_Lighthouse.jpg",
      alt: "Prospect Harbor lighthouse with fishing boats on the water"
    }
  ]
};

export const attractionsData = {
  title: "Discover the Schoodic Peninsula",
  subtitle: "Your gateway to Acadia's hidden treasures",
  
  attractions: [
    {
      id: 1,
      name: "Schoodic Point",
      distance: "5 miles",
      description: "Dramatic coastal views where waves crash against pink granite rocks. Less crowded than the main Acadia loop, offering peaceful exploration.",
      image: "https://images.pexels.com/photos/29360923/pexels-photo-29360923.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      activities: ["Photography", "Tide pooling", "Scenic drives"]
    },
    {
      id: 2,
      name: "Acadia National Park",
      distance: "15 miles to Bar Harbor",
      description: "Experience 49,000 acres of stunning wilderness, hiking trails, and breathtaking ocean vistas. Cadillac Mountain, Jordan Pond, and more await.",
      image: "https://images.pexels.com/photos/9711061/pexels-photo-9711061.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      activities: ["Hiking", "Biking", "Wildlife viewing"]
    },
    {
      id: 3,
      name: "Winter Harbor",
      distance: "3 miles",
      description: "Charming working harbor village with local seafood restaurants, art galleries, and authentic Maine character.",
      image: "https://images.unsplash.com/photo-1655758267582-463a17ed85c5",
      activities: ["Dining", "Shopping", "Harbor walks"]
    },
    {
      id: 4,
      name: "Coastal Lighthouses",
      distance: "Various locations",
      description: "Visit iconic Maine lighthouses including Bass Harbor Head Light and Prospect Harbor Light. Perfect for photography enthusiasts.",
      image: "https://images.unsplash.com/photo-1715022620029-597a1a9b1642",
      activities: ["Photography", "Sightseeing", "History"]
    },
    {
      id: 5,
      name: "Hiking Trails",
      distance: "Nearby",
      description: "Explore numerous trails ranging from easy coastal walks to challenging mountain hikes. Experience Maine's diverse terrain.",
      image: "https://images.pexels.com/photos/13606567/pexels-photo-13606567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      activities: ["Hiking", "Nature walks", "Bird watching"]
    },
    {
      id: 6,
      name: "Wildlife Watching",
      distance: "Throughout the area",
      description: "Spot seals, eagles, osprey, and more. The Schoodic area is rich with wildlife opportunities year-round.",
      image: "https://images.unsplash.com/photo-1633532501149-e711ccffc358",
      activities: ["Wildlife viewing", "Bird watching", "Photography"]
    }
  ]
};

export const seasonalData = {
  title: "Experience Every Season",
  
  seasons: [
    {
      name: "Spring",
      months: "April - June",
      icon: "Flower2",
      description: "Witness nature's awakening with wildflowers blooming and migratory birds returning.",
      highlights: [
        "Wildflower blooms",
        "Bird migration",
        "Fewer crowds",
        "Mild temperatures"
      ],
      image: "https://images.unsplash.com/photo-1636037620707-ffde6f67f0e4"
    },
    {
      name: "Summer",
      months: "July - August",
      icon: "Sun",
      description: "Perfect weather for all outdoor activities. Warm days, cool evenings, and endless adventures.",
      highlights: [
        "Beach days",
        "Kayaking",
        "Perfect hiking weather",
        "Local festivals"
      ],
      image: "https://images.unsplash.com/photo-1683249497111-ffabbf78bbe6"
    },
    {
      name: "Fall",
      months: "September - November",
      icon: "Leaf",
      description: "Experience Maine's legendary fall foliage. The most spectacular season with vibrant colors.",
      highlights: [
        "Peak foliage",
        "Harvest festivals",
        "Comfortable hiking",
        "Photography paradise"
      ],
      image: "https://images.pexels.com/photos/35046702/pexels-photo-35046702.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    },
    {
      name: "Winter",
      months: "December - March",
      icon: "Snowflake",
      description: "Peaceful and serene. Cozy up by the fireplace with dramatic coastal winter views.",
      highlights: [
        "Dramatic waves",
        "Cozy cabin vibes",
        "Winter wildlife",
        "Northern lights possible"
      ],
      image: "https://images.pexels.com/photos/35046715/pexels-photo-35046715.jpeg"
    }
  ]
};

export const availabilityData = {
  // This would be updated from Airbnb API in production
  message: "Check live availability on Airbnb",
  bookingUrl: "https://www.airbnb.com/rooms/1411071628689314814"
};
